import { render } from "./DiscosPage.vue?vue&type=template&id=7befeebf&scoped=true"
import script from "./DiscosPage.vue?vue&type=script&lang=js"
export * from "./DiscosPage.vue?vue&type=script&lang=js"

import "./DiscosPage.vue?vue&type=style&index=0&id=7befeebf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7befeebf"]])

export default __exports__